import { ChevronDownIcon, CopyIcon } from '@radix-ui/react-icons';
import { useRef } from 'react';

import { Button } from '../../../primitives/button';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '../../../primitives/drawer';
import { ScrollArea, ScrollBar } from '../../../primitives/scroll-area';
import { ButtonClipboard } from '../../button/button-clipboard';
import {
  InputVariantSchema as InputVariantSchemaUI,
  type InputVariantSchemaProps,
  type InputVariantSchemaRef,
} from '../../input/input-variant-schema';

export function InputVariantSchema({
  disabled = false,
  value = { ranges: [], saltBase: '' },
  onChange,
  saltBaseOptions,
  onSaltBaseChange,
}: InputVariantSchemaProps) {
  const inputRef = useRef<InputVariantSchemaRef>(null);

  const seed =
    value?.saltBase && value?.salt
      ? `${value.saltBase} + ${value.salt}`
      : value?.saltBase
        ? value.saltBase
        : value?.salt
          ? value.salt
          : undefined;

  const triggerButton = (
    <Button
      title="Configurar variantes"
      className="h-auto min-h-[4.5rem] flex-auto justify-between gap-4 rounded-lg px-3 py-2 select-none"
      disabled={disabled}
      variant="outline"
    >
      <p className="grid space-y-1 text-left">
        <span className="truncate text-sm">
          {value.ranges.length < 2 ? (
            'Seleccionar'
          ) : (
            <>
              Variantes:{' '}
              <span className="rounded-lg bg-accent px-2 text-accent-foreground">
                {value.ranges.length}
              </span>
            </>
          )}
        </span>
        <span className="truncate text-xs">Semilla: {seed || 'seleccionar'}</span>
      </p>
      <ChevronDownIcon className="size-4 opacity-50" />
    </Button>
  );

  return (
    <div className="flex items-center gap-4">
      <ButtonClipboard
        className="flex-none"
        disabled={!seed}
        label={<CopyIcon className="size-4" />}
        size="icon"
        title="Copiar semilla"
        valueToCopy={`semilla: ${seed}`}
      />
      <Drawer handleOnly>
        {!disabled ? <DrawerTrigger asChild>{triggerButton}</DrawerTrigger> : triggerButton}

        <DrawerContent onAnimationEnd={() => inputRef.current?.cancelRange()}>
          <DrawerHeader className="p-0">
            <DrawerTitle className="sr-only">Configurar variantes</DrawerTitle>
            <DrawerDescription className="sr-only">Configurar variantes</DrawerDescription>
          </DrawerHeader>

          <ScrollArea className="grid size-full">
            <div className="m-auto w-full pb-4 max-md:px-10 md:w-[650px]">
              <InputVariantSchemaUI
                disabled={disabled}
                ref={inputRef}
                saltBaseOptions={saltBaseOptions}
                value={value}
                onChange={onChange}
                onSaltBaseChange={onSaltBaseChange}
              />
            </div>
            <ScrollBar orientation="vertical" />
          </ScrollArea>

          <DrawerFooter className="border-t px-0">
            <div className="m-auto w-full max-md:px-10 md:w-[650px]">
              <DrawerClose asChild>
                <Button className="w-full">Continuar</Button>
              </DrawerClose>
            </div>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </div>
  );
}
